export default __webpack_public_path__ + "static/media/Цинк_20л.bb204e3f.jpg";